export default __webpack_public_path__ + "static/media/rocket_anim_121.7c1458ec.png";